import * as R from 'ramda'
import {
  GetPickersBindings,
  HasVisibleBenefitsPicker,
  HasVisibleDepartureCityPicker,
  HasVisibleDepartureDatePicker,
  HasVisibleDurationPicker,
  HasVisibleParticipantsPicker,
  HasVisiblePicker,
  IsPackageOutOfStock,
  PackageBelongsToProduct
} from './packages.types'

export const hasVisiblePicker: HasVisiblePicker = pickerName => R.path(['ecomm', 'pickers', pickerName, 'visible'])
export const hasVisibleDepartureCityPicker: HasVisibleDepartureCityPicker = hasVisiblePicker('departureCity')
export const hasVisibleDepartureDatePicker: HasVisibleDepartureDatePicker = hasVisiblePicker('departureDate')
export const hasVisibleDurationPicker: HasVisibleDurationPicker = hasVisiblePicker('duration')
export const hasVisibleParticipantsPicker: HasVisibleParticipantsPicker = hasVisiblePicker('participants')
export const hasVisibleBenefitsPicker: HasVisibleBenefitsPicker = hasVisiblePicker('benefits')

export const isPackageOutOfStock: IsPackageOutOfStock = R.prop('outOfStock')

export const packageBelongsToProduct: PackageBelongsToProduct = R.curry(
  (pack, product) =>
    R.contains(pack.key, product.resources)
)

export const getPickersBindings: GetPickersBindings = packageResource => (
  R.path(['ecomm', 'aggregatedPickerBindings'], packageResource)
)
